export const TRIP = {
    createDialog: 'trip-create-dialog',
    nameInput: 'trip-name-input',
    destinationInput: 'trip-destination-input',
    startDateButton: 'trip-start-date-button',
    endDateButton: 'trip-end-date-button',
    submitButton: 'trip-create-submit-button',
    detailContainer: 'trip-detail-container',
    inviteLink: 'trip-invite-link',
    copyInviteButton: 'trip-copy-invite-button',
    tabIdeas: 'trip-tab-ideas',
    tabPreferences: 'trip-tab-preferences',
    tabVotes: 'trip-tab-votes',
    tabItinerary: 'trip-tab-itinerary',
    tabBudget: 'trip-tab-budget',
};

export const TRIP_DETAILS = {
    section: 'trip-details-section',
    toggleButton: 'trip-details-toggle',
    summary: 'trip-details-summary',
    body: 'trip-details-body',
    savingIndicator: 'trip-details-saving',
    arrivalDate: 'trip-details-arrival-date',
    arrivalTime: 'trip-details-arrival-time',
    arrivalAirport: 'trip-details-arrival-airport',
    arrivalFlight: 'trip-details-arrival-flight',
    departureDate: 'trip-details-departure-date',
    departureTime: 'trip-details-departure-time',
    departureAirport: 'trip-details-departure-airport',
    departureFlight: 'trip-details-departure-flight',
    hotelName: 'trip-details-hotel-name',
    hotelAddress: 'trip-details-hotel-address',
    checkinTime: 'trip-details-checkin-time',
    checkoutTime: 'trip-details-checkout-time',
};

export const TRANSIT_CONNECTOR = {
    root: 'itinerary-transit-connector',
};

export const PIN_DIALOG = {
    root: 'pin-idea-dialog',
    tripSelect: 'pin-idea-trip-select',
    submitButton: 'pin-idea-submit-button',
};

export const START_PLANNING_DIALOG = {
    root: 'start-planning-dialog',
    nameInput: 'start-planning-name-input',
    startDateButton: 'start-planning-start-date-button',
    endDateButton: 'start-planning-end-date-button',
    submitButton: 'start-planning-submit-button',
};
